import { Box } from '@mui/material'
import {
  FrozenProductionRow,
  FrozenProductionTableProps,
} from './EditSettings.types'
import { GridColDef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'

export const FrozenProductionMUITable = ({
  data,
}: FrozenProductionTableProps) => {
  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'Base source site',
        field: 'baseSourceSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Workcentre',
        field: 'workCentreCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'SKU code',
        field: 'skuCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Production date',
        field: 'productionDateKeyFormatted',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Frozen production amount',
        field: 'frozenProductionAmount',
        flex: 1,
        type: 'number',
      },
    ],
    [data]
  )

  // No-op functions for BaseTable required props (read-only table)
  const updateTableData = () => {
    // This is a read-only table, no updates needed
  }

  const uploadData = () => {
    // No upload functionality needed
  }

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={false}
        updateTableData={updateTableData}
        uploadData={uploadData}
        isUploading={false}
        isSaving={false}
        checkBoxSelection={false}
        showTableToolBar={false}
        pinnedColumns={['baseSourceSiteCode', 'workCentreCode']}
        downloadFileName="FrozenProduction"
      />
    </Box>
  )
}
